export const menuContextKey = Symbol('menuContextKey')
export const subMenuContextKey = Symbol('subMenuContextKey')